
<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title" *ngIf="inner_DeviceBehfaFilterGroup.id==0">فرم ثبت گروه جدید </h5>
    <h5 class="card-title" *ngIf="inner_DeviceBehfaFilterGroup.id>0">فرم ویرایش گروه '{{inner_DeviceBehfaFilterGroup.title}}' </h5>
    <form [formGroup]="DeviceBehfaFilterGroupForm">

      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> عنوان </label>
          <input formControlName="title" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_title().valid && get_Form_title().touched" class="form-text text-muted MyErrorRedColor">عنوان را وارد نمائید.</small>
        </div>
      </div>

      <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      <button *ngIf="!InProccessing" type="button"  (click)="OnSubmit()" [disabled]="!DeviceBehfaFilterGroupForm.valid" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
      <button (click)="onBack()" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>
    </form>




  </div>
</div>
